var _excluded = ["title", "titleTypography", "text", "footer", "isOpen", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import OnColorContext from "../../../contexts/OnColorContext";
import { KeyboardEventKeys } from "../../../typings/types";
import TextAtm from "../../atoms/TextAtm";
import { ContentWrapper, Header, IconArrow, Wrapper } from "./AccordionMol.styled";
export var defaultProps = {
  titleTypography: "big3"
};
function AccordionMol(_ref) {
  var title = _ref.title,
    _ref$titleTypography = _ref.titleTypography,
    titleTypography = _ref$titleTypography === void 0 ? defaultProps.titleTypography : _ref$titleTypography,
    text = _ref.text,
    footer = _ref.footer,
    isOpen = _ref.isOpen,
    onClick = _ref.onClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var _useState = useState(!!isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenValue = _useState2[0],
    setIsOpen = _useState2[1];
  var handleToggle = function handleToggle(open) {
    setIsOpen(function (value) {
      return open !== null && open !== void 0 ? open : !value;
    });
    if (onClick) {
      onClick(open !== null && open !== void 0 ? open : isOpenValue);
    }
  };
  useEffect(function () {
    if (isOpen !== undefined) {
      setIsOpen(isOpen);
    }
  }, [isOpen]);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE) {
      event.preventDefault();
      handleToggle();
    }
    if (event.key === KeyboardEventKeys.ESC) {
      event.preventDefault();
      handleToggle(false);
    }
    if (event.key === KeyboardEventKeys.TAB && !isOpenValue) {
      event.preventDefault();
      handleToggle();
    }
  };
  var handleHeaderClick = function handleHeaderClick() {
    if (!isOpenValue) {
      handleToggle();
    }
  };
  var id = uuidv4();
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $onColor: onColor
  }, restProps, {
    tabIndex: 0,
    "aria-expanded": isOpenValue,
    onKeyDown: handleKeyDown,
    "aria-controls": id
  }), /*#__PURE__*/React.createElement(Header, {
    onClick: handleHeaderClick,
    $hasHiddenArrow: !!isOpenValue
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: titleTypography
  }, title), !isOpenValue && /*#__PURE__*/React.createElement(IconArrow, {
    $isOpen: isOpenValue,
    $titleTypography: titleTypography,
    $onColor: onColor
  })), /*#__PURE__*/React.createElement(ContentWrapper, {
    id: id,
    isOpen: isOpenValue
  }, text, footer));
}
export default AccordionMol;